const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

const throttle = (func, limit) => {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

const debounce = (func, delay) => {
  let inDebounce;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

const showPopoverContent = (e, popoverWrap) => {
  popoverWrap.classList.remove("loading");

  const title = e.target.getAttribute("data-title");
  const meta = e.target.getAttribute("data-meta");
  const description = e.target.getAttribute("data-description");
  const image = e.target.getAttribute("data-image");

  if (e.target.getAttribute("data-no-popover")) {
    popoverWrap.classList.remove("active");
    return;
  }

  const displayPopoverItem = (el, val, type = "text") => {
    if ("" === val) {
      el.style.display = "none";
      return;
    }

    switch (type) {
      case "html":
        el.innerHTML = val;
        break;

      case "image":
        el.setAttribute("src", val);
        break;

      default:
        el.textContent = val;
    }

    el.style.display = "block";
  };

  displayPopoverItem(
    popoverWrap.querySelector(".popover-title"),
    title,
    "html"
  );
  displayPopoverItem(popoverWrap.querySelector(".popover-meta"), meta);
  displayPopoverItem(
    popoverWrap.querySelector(".popover-description"),
    description
  );
  displayPopoverItem(
    popoverWrap.querySelector(".popover-image"),
    image,
    "image"
  );
};

const watchScrollDirection = () => {
  let scrollPos = 0;

  window.addEventListener("scroll", function () {
    if (document.body.getBoundingClientRect().top > scrollPos)
      document.body.setAttribute("data-scroll-direction", "UP");
    else document.body.setAttribute("data-scroll-direction", "DOWN");
    scrollPos = document.body.getBoundingClientRect().top;
  });
};

export {
  copyToClipboard,
  throttle,
  debounce,
  showPopoverContent,
  watchScrollDirection,
};
